import Image from 'next/image';
import styled from 'styled-components';

export const ExistFullScreen = styled.button`
  position: fixed;
  top: 30px;
  right: 40px;
  width: 50px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.palette.darkGrey};
  opacity: 0.8;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  border: none;
  cursor: pointer;
  z-index: 1000;
`;

export const CustomSlideButton = styled.button`
  width: 50px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.palette.darkGrey};
  opacity: 0.8;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  border: none;
  cursor: pointer;

  svg {
    height: 18px;
    width: 18px;
  }
`;

export const SlideLeftWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 40px;
  transform: translateY(-50%);
  z-index: 1000;
`;

export const SlideRightWrapper = styled.div`
  position: fixed;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  z-index: 1000;
`;

export const FullScreenWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${({ theme }) => theme.palette.black};
  z-index: 1000;
`;

export const FullScreenContent = styled.div`
  max-height: 808px !important;
  height: 808px !important;
  width: auto;
  max-width: fit-content;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);

  & img {
    object-fit: contain !important;
    width: 100%;
    height: 100%;
  }
`;

export const FullScreenLabel = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.white};
  display: block;
  margin-right: auto;
  margin-top: 10px;
  position: absolute;
  bottom: -30px;
  left: 0;
`;

export const FullScreenTotalItems = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  & span {
    top: 0;
  }
`;

export const FullScreenGalleryTitle = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: ${(p) => p.theme.palette.white};
  line-height: 1;
  position: absolute;
  top: -25px;
  left: 0;
`;

export const StyledImage = styled(Image)`
  position: relative !important;
  border-radius: 8px;
`;
